import React from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import './CustomCheckBox.scss';

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (e: CheckboxChangeEvent) => void;
}

export default function CustomCheckBox({ checked, onChange }: Readonly<CustomCheckboxProps>) {
  return (
    <Checkbox
      className='custom-checkbox'
      style={{ width: '22px', marginRight: '8px', marginBottom: '2px' }}
      checked={checked}
      onChange={onChange} />);
};